import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

const ActivityTypes = ({ permissions }) => (
  <Standard
    classes="bhp-activity"
    canAdmin={permissions.CanAdminActivities()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.activityType,
      list: REDUCER_KEY.activityTypes
    }}
    config={config}
    permissions={permissions}
  />
);

ActivityTypes.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default ActivityTypes;
